
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoChargeFull as ObiBatteryVerticalPluggedNoChargeFullElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-full.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoChargeFull = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-full',
   elementClass: ObiBatteryVerticalPluggedNoChargeFullElement,
   events: {
     
   }
  });
 
 